export default __webpack_public_path__ + "static/media/NubMaduro.8f9fd8d4.png";